import React, { useEffect, useState } from "react";
import DynamicActionBar from "../../Common/DynamicActionBar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import DynamicBoxGrid from "../../Common/DynamicBoxGrid";
import { Api } from "../../Service/api";
import { getlocalStorage } from "../../Service/api/configuration/localstorage";
import { ACTIONS } from "../../redux/actions";
import { ErrorToast, SuccessToast } from "../../Common/Toast";
import SideDrawer from "../../Common/SideDrawer";
import { path } from "../../Utils/ScreenPath";
import SubjectPurchase from "../../Common/SubjectPurchase";

const QtypeSection = () => {
  const navigate = useNavigate();
  const { EditId, divisionIndex, replaceId, sectionIndex } = useParams();
  const dispatch = useDispatch();
  const userData = getlocalStorage("userData");
  // let { sectionIndex, divisionIndex } = useParams();
  const selectedData = useSelector((state) => state?.SelectedDetail?.Data);

  const [qtype, setQtype] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isDrawerData, setIsDrawerData] = useState([]);
  const [isLocked, setIsLocked] = useState(true);
  const [isPurchaseModelOpen, setIsPurchaseModelOpen] = useState(false);

  let questionCount =
    selectedData?.sections_info?.[sectionIndex]?.divisions?.[divisionIndex]
      ?.question_data?.length;
  const actions = [{ label: "Selected Q. : " + `${questionCount}` }];

  const handleBackClick = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  const handleDataClick = (selectedQtype) => {
    setIsDrawerData(selectedQtype);
    setIsOpen(true);
  };

  const closeDrawer = () => setIsOpen(false);

  const handleItemClick = (item, index) => {
    if (isLocked && index > 1) {
      setIsPurchaseModelOpen(true);
      closeDrawer();
    } else {

      if (replaceId) {

        navigate(
          path?.QuestionSection +
          `/${sectionIndex}/${divisionIndex}/${isDrawerData?.id}/${item?.id}/${replaceId}/${EditId}`
        );
      }
      else {

        navigate(
          path?.QuestionSection +
          `/${sectionIndex}/${divisionIndex}/${isDrawerData?.id}/${item?.id}`
        );
      }
    }
  };

  const _getQtype = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let payload = {
        boardId: userData?.board_id,
        mediumId: userData?.medium_id,
        standard: selectedData?.standard_id,
        semester: selectedData?.semester_id,
        subject: selectedData?.subject_id,
        limit: 1000,
        offset: 1,
        userId: userData?.user_id,
      };
      const { data } = await Api.GetQtype(payload);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        setQtype(res?.data);
        setIsLocked(res?.isLocked);
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  useEffect(() => {
    _getQtype();
  }, []);

  const onPaymentSuccess = () => {
    setIsPurchaseModelOpen(false);
    closeDrawer();
    _getQtype();
  };


  return (
    <div>
      <DynamicActionBar
        showArrowLeft
        backButtonLabel={selectedData?.subject_name}
        onBackClick={handleBackClick}
        actions={actions}
      />
      <DynamicBoxGrid
        type="qtype"
        subjects={qtype}
        onQtypeClick={handleDataClick}
      />
      <SideDrawer
        isOpen={isOpen}
        onClose={closeDrawer}
        title="Match the Following"
        items={isDrawerData?.chapter_info}
        onItemClick={handleItemClick}
        isLocked={isLocked}
      />
      <SubjectPurchase
        isModelOpen={isPurchaseModelOpen}
        setIsPurchaseModelOpen={setIsPurchaseModelOpen}
        selectedDrpData={{
          standard: {
            id: selectedData?.standard_id,
            name: selectedData?.standard_name,
          },
          subject: {
            id: selectedData?.subject_id,
            subject: selectedData?.subject_name,
          },
          semester: {
            id: selectedData?.semester_id,
            semester: selectedData?.semester_name,
          },
          board: {
            board_name: selectedData?.board,
          },
          medium: {
            name: selectedData?.medium,
          },
        }}
        onPaymentSuccess={onPaymentSuccess}
      />
    </div>
  );
};

export default QtypeSection;
